import React from 'react';
import * as LucideIcons from 'lucide-react';

import { useAppContext } from '../AppContext';
import { useTranslation } from 'react-i18next';

function NexusQuests({ quests }) {
    const { t } = useTranslation();
    const questList = Object.values(quests);

    if (questList.length === 0) {
        return <div className="text-center text-gray-400 p-8">{t('nexusQuests.noQuests')}</div>;
    }

    return (
        <div className="space-y-4">
            <h3 className="text-xl font-bold text-center text-blue-200 font-playfair">{t('nexusQuests.title')}</h3>
            {questList.map(quest => {
                const progressPercentage = (quest.progress / quest.target) * 100;
                return (
                    <div key={quest.title} className={`p-4 rounded-lg border ${quest.completed ? 'bg-green-900/20 border-green-500/30' : 'bg-gray-800/50 border-gray-700/50'}`}>
                        <div className="flex justify-between items-center">
                            <h4 className="font-bold text-white">{quest.title}</h4>
                            {quest.completed ? (
                                <span className="flex items-center gap-2 text-sm font-bold text-green-400"><LucideIcons.CheckCircle2 size={16} /> {t('nexusQuests.complete')}</span>
                            ) : (
                                <span className="text-sm font-mono text-gray-400">{quest.progress} / {quest.target}</span>
                            )}
                        </div>
                        <p className="text-sm text-gray-300 mt-1">{quest.description}</p>
                        <div className="w-full bg-black/50 rounded-full h-2.5 mt-3">
                            <div className={`h-2.5 rounded-full ${quest.completed ? 'bg-green-500' : 'bg-blue-500'}`} style={{ width: `${progressPercentage}%` }}></div>
                        </div>
                        <p className="text-right text-xs font-bold text-yellow-400 mt-2">{t('nexusQuests.reward')}: {quest.luminance} Luminance</p>
                    </div>
                );
            })}
        </div>
    );
}

export default NexusQuests;